import { browserHistory } from 'react-router';

import {
  accounts,
  missionControl,
  missionControlSubHeaderOptions,
  settings,
} from '../HeaderOptions';
import { store } from '../index';
import { getLocalStorageItem } from '../utilities/localStorage';
import { canPerformAction } from '../utilities/permissionUtils';
import { getLoggedAdmin, isLoggedAdminUser } from '../utilities/ServiceManager';

const redirectOptions = [
  ...missionControlSubHeaderOptions,
  ...accounts,
  ...settings,
  ...missionControl,
];

export function redirect(permissions) {
  const match = redirectOptions.find(
    (option) =>
      option.permission && canPerformAction(option.permission, permissions),
  );

  if (match) {
    browserHistory.replace(match.route);
  }
}

export function checkLoginAuthorization({ dispatch }) {
  return (nextState, replace, next) => {
    const hashPath = window.location.hash;
    if (!hashPath?.includes('logout')) {
      isLoggedAdminUser().then(({ data }) => {
        if (data) {
          getLoggedAdmin().then(() => {
            const permissions = store.getState().login.get('permissions');
            redirect(permissions);
          });
        }
      });
    }
    next();
  };
}

export function checkAuthorization({ dispatch, getState }, name) {
  return (nextState, replace, next) => {
    getLoggedAdmin().then(() => {
      const permissions = store.getState().login.get('permissions');
      const loading = store.getState().login.get('loading');

      // Check if user has permission to view the page
      if (canPerformAction(name, permissions)) {
        return next();
      }

      if (getLocalStorageItem('loading') || loading) {
        browserHistory.replace('/loading');
        return next();
      }

      // User doesn't have permission - redirect to 401
      browserHistory.replace('/401');
      return next();
    });
  };
}
